<template>
  <dialog-email
    :isLoading="isLoading"
    ref="dialogEmail"
    :contentKey="contentKey"
    :contentMap="contentData"
    :data="emailData"
    @on-submit-email="onSubmitEmail"
  >
  </dialog-email>
</template>

<script>
import { ServiceRFQs } from '@/services/RFQs'
import { toDate } from '@/utils/filters'
import { ServiceEmailMessages } from '@/services/email-messages'

export default {
  name: 'DialogSendOrderAckn',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  props: {
    rfqID: { required: true }
  },
  data () {
    return {
      isLoading: false,
      logoType: 0,
      dataRFQ: {},
      emailData: {},
      contentData: {}
    }
  },
  computed: {
    contentKey () {
      return 'po-acknowledgment-email'
    },
    emailSubject () {
      return this.L10n('order-acknowledgment-for-po')
    }
  },
  methods: {
    show ({ logoType }) {
      this.logoType = logoType
      this.$refs.dialogEmail.show()
      this.loadData()
    },
    hide () {
      this.logoType = 0
      this.dataRFQ = {}
      this.contentData = {}
      this.isLoading = false
      this.emailData = {}

      this.$refs.dialogEmail.hide()
    },
    onSubmitEmail (data) {
      this.requestSubmitEmail(data)
    },
    async requestSubmitEmail (emailData) {
      this.isLoading = true
      try {
        await ServiceEmailMessages.sendOrderAcknowledgment({
          id: this.dataRFQ.id,
          logoKey: this.logoType,
          translate: this.L10n,
          ...emailData
        })
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
        this.hide()
      }
    },
    loadData () {
      this.isLoading = true
      return Promise
        .all([
          this.loadDataRFQ()
        ])
        .then(() => {
          this._createContentData({ ...this.dataRFQ })
          this._createEmailData()
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loadDataRFQ () {
      let params = {
        select: [
          'id', 'customerCompany.name as customerCompanyName', 'customerContact.name as customerContactName',
          'customerContact.email as email', 'po', 'poDate'
        ].join(',')
      }
      return ServiceRFQs.getDynamic(this.rfqID, params)
        .then(({ data }) => {
          this.dataRFQ = data
        })
    },
    _createEmailData () {
      let subject = this.emailSubject
      let emailToList = []
      this.dataRFQ.email && emailToList.push(this.dataRFQ.email)
      this.emailData = {
        subject,
        emailToList
      }
    },
    _createContentData (data) {
      const noValue = '--NO VALUE--'
      this.contentData = {
        'customerContactName': data.customerContactName || noValue,
        'customerCompanyName': data.customerCompanyName || noValue,
        po: data.po || noValue,
        poDate: toDate(data.poDate) || noValue
      }
    }
  }
}
</script>
